import { useState } from "react";
import { Navbar, Nav, Container } from "react-bootstrap";
import { useNavigate } from "react-router";
import "../../styles/Navbar.scss";

function CustomNavbar({ sameSite = true }) {
    const [expanded, setExpanded] = useState(false);
    const navigate = useNavigate();

    const handleNavLinkClick = (href) => {
        // Close mobile menu when link is clicked
        setExpanded(false);

        if (!sameSite) {
            navigate("/");
            setTimeout(() => {
                if (href.startsWith("#")) {
                    document.querySelector(href)?.scrollIntoView({ behavior: 'smooth' });
                } else {
                    window.location.href = href;
                }
            }, 100);
        } else {
            if (href.startsWith("#")) {
                document.querySelector(href)?.scrollIntoView({ behavior: 'smooth' });
            } else {
                window.location.href = href;
            }
        }
    };

    return (
        <Navbar
            expand="lg"
            expanded={expanded}
            onToggle={setExpanded}
            className="custom-navbar shadow-sm"
            fixed="top"
        >
            <Container>
                <Navbar.Brand
                    href="#"
                    onClick={(e) => {
                        e.preventDefault();
                        handleNavLinkClick("#");
                    }}
                    className="navbar-brand-custom"
                >
                    <img
                        src="./img/misc/logo.png"
                        alt="LOR IT-Service Logo"
                        className="navbar-logo"
                    />
                </Navbar.Brand>

                <Navbar.Toggle
                    aria-controls="basic-navbar-nav"
                    className="custom-toggler"
                />

                <Navbar.Collapse id="basic-navbar-nav">
                    <Nav className="ms-auto navbar-nav-custom">
                        <Nav.Link
                            onClick={() => handleNavLinkClick("#services")}
                            className="nav-link-custom"
                        >
                            Leistungen
                        </Nav.Link>
                        <Nav.Link
                            onClick={() => handleNavLinkClick("#team")}
                            className="nav-link-custom"
                        >
                            Unser Team
                        </Nav.Link>
                        <Nav.Link
                            onClick={() => handleNavLinkClick("#history")}
                            className="nav-link-custom"
                        >
                            Historie
                        </Nav.Link>
                        <Nav.Link
                            onClick={() => handleNavLinkClick("#testimonials")}
                            className="nav-link-custom"
                        >
                            Kundenmeinungen
                        </Nav.Link>
                        <Nav.Link
                            onClick={() => handleNavLinkClick("#contact")}
                            className="nav-link-custom"
                        >
                            Kontakt
                        </Nav.Link>
                        <Nav.Link
                            onClick={() => handleNavLinkClick("https://shop.lorentschitsch.at/")}
                            className="nav-link-custom nav-link-shop"
                        >
                            Web-Shop
                        </Nav.Link>
                    </Nav>
                </Navbar.Collapse>
            </Container>
        </Navbar>
    );
}

export default CustomNavbar;
